import React from 'react'


const h1Styles = {fontSize: 45 + 'px', marginLeft: '100px', marginRight: '100px', marginTop: '100px', marginBottom: '0', paddingBottom: '0', letterSpacing: '5px'}
const linkStyles = {fill: 'purple', backgroundColor: "white", fontSize: '40', fontFamily: 'Montserrat Alternates, sans-serif', textDecoration: 'none', margin: '20px'}
const textStyles = { fontFamily: 'Montserrat Alternates, sans-serif', textAlign: 'left', marginLeft: '300px'}
const pStyles = {marginLeft:'230px', marginRight:'230px', marginTop:'100px', fontSize: '25px', fontFamily: 'Montserrat Alternates, sans-serif', textAlign: 'left'}
const liStyles = {marginLeft:'230px', marginRight:'230px', fontSize: '25px', fontFamily: 'Montserrat Alternates, sans-serif'}
const itemsStyles = {margin:'10px', fontSize: '25px', fontFamily: 'Montserrat Alternates, sans-serif', textAlign: 'left'}
const imageStyles = {height: '400px', width: '500px',}


const GaryBuseyLookALikes = () => {

    return (
        <div style={{width: '1000px', zoom: '0.5', textAlign: 'center', margin: '0 auto', position: 'relative'}}>
            
            <h1 style={h1Styles}>Gary Busey Look-A-Likes</h1>

            <h2 style={textStyles}>ruby | ruby on rails | Heroku | PostgreSQL</h2>

            <div style={textStyles}>
            <a style={linkStyles} href='https://github.com/Nickphammond/garry_busey_lookalike_app'>Github rep</a>
            <a style={linkStyles} href='https://gary-busey-lookalike-market.herokuapp.com/'>Deployed site!</a>
            
            </div>

                <p style={pStyles}>Do you have a special occasion coming up,
                but no Gary Busey look-a-like....</p>
                <img style={imageStyles} src={'images/gb1.jpg'} alt={'kids party'}></img>
                <p style={pStyles}>An untapped market, this app connects Gary Busey look-a-likes with those who need their services.</p>
                <br></br>
                <img style={imageStyles} src={'images/gb2.jpg'} alt={'corporate event'}></img>
                <p style={pStyles}>For those planning:</p>
                <ul style={liStyles}>
                    <li style={itemsStyles}>birthday parties</li>
                    <li style={itemsStyles}>bar mitzvahs</li>
                    <li style={itemsStyles}>work x-mas parties</li>
                    <li style={itemsStyles}>weddings</li>
                </ul>
            


                {/* <div style={backStyles}>
                <Link style={backStyles} to="/">
                    BACK
                </Link>
                </div> */}
        </div>
    )
}

export default GaryBuseyLookALikes